module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/title_reason-481094ee03e35b56fb341703b5f32abd.svg";